import * as Events from "../utils/events";
import Base2DElement from "./base-2d-element";
import AssetLibrary from "../assets/asset-library";

class CylinderInfo extends Base2DElement {
    get type2d() { return "CylinderInfo"; }

    _createContainer() {
        const container = super._createContainer();

        container.classList.add("interactable-geometry");

        const name = document.createElement("li");
        name.innerText = "Cylinder";
        name.classList.add("igeo-name");
        container.appendChild(name);

        return container;
    }

    _initDefaultVars() {
        super._initDefaultVars();

        this._cylinder = null;
        this._hoveringFormula = null;
        this._formulas = [];
        this._values = [];
        this._formulaLabels = [];
        this._hidden = false;
    }

    _initValues(options) {
        this._cylinder = "cylinder" in options ? options.cylinder : this._cylinder;
    }

    get cylinder() { return this._cylinder; }
    set cylinder(val) { this._cylinder = val; }

    constructor(options, parentLayer, uuid) {
        super(options, parentLayer, uuid);

        this._valuesChanged = ({ object: cylinder, formulas, values, hidden }) => {
            if (cylinder.uuid === this._cylinder) {
                this._formulas = formulas;
                this._values = values;
                this._hidden = hidden;
                this.needsUpdate = true;
            }
        };

        Events.listen("cylinder_change_values", this._valuesChanged);
    }

    setCylinder(cylinder) {
        this._cylinder = cylinder;
        this.needsUpdate = true;
    }

    redraw(width, height) {
        this._updateLabels();
    }

    delete() {

        Events.unlisten("cylinder_change_values", this._valuesChanged);

        this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 1);

        delete this.domElement;

        if (Q3.selected === this) {
            Q3.selected = null;
            Events.fire("selectchange");
        }

    }

    _updateLabels() {
        let show = Boolean(this._cylinder) && !this._hidden;
        this.domElement.classList.toggle("hidden", !show);

        let values = this._values, formulas = this._formulas;
        let formulaLabels = this._formulaLabels;

        while (formulaLabels.length > formulas.length) {
            let li = formulaLabels.pop();
            this.domElement.removeChild(li);
        }
        while (formulaLabels.length < formulas.length) {
            let li = document.createElement("li");
            this.domElement.appendChild(li);
            formulaLabels.push(li);
        }

        for (let i = 0; i < formulas.length; i++) {
            let [formula, li] = [formulas[i], formulaLabels[i]];
            li.innerHTML = "";

            formula.formula.map(({ text, key }) => {
                let span = document.createElement("span");
                span.innerText = text;
                //span.style.pointerEvents = "auto";
                li.appendChild(span);

                if (key) {
                    span.onmouseover = () => {
                        this._hoveringFormula = key;
                        span.classList.add("hover");
                    }
                    span.onmouseleave = () => {
                        this._hoveringFormula = null;
                    }
                }
            });

            let span = document.createElement("span");
            span.innerText = ` = ${values[i].toFixed(2)}${formula.unit ? " " + formula.unit : ""}`;
            //span.style.pointerEvents = "auto";
            li.appendChild(span);
        }

        if (this._hoveringFormula) {
            let object = AssetLibrary.objects[this._cylinder];
            if (object) {
                object._interactables.colliders[this._hoveringFormula].highlight();
            }
        }
    }
}

export default CylinderInfo;
export { CylinderInfo };
